import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {getSession} from '../lib/auth-api';
import {setSession} from '../reducers/session';

// const PORTAL_LOGIN =
//     window.RUNTIME_CONFIG?.PORTAL_LOGIN ||
//     'https://unicorn.cusc.vn/login';

const PORTAL_LOGIN = 'https://unicorn.cusc.vn/login';

class AuthSessionLoader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true
        };
    }

    async componentDidMount () {
        try {
            const data = await getSession();

            this.props.onSetSession(data.session);
            
            // ❌ chưa login
            if (!data?.session?.user) {
                window.location.href = PORTAL_LOGIN;
                return;
            }

            // ✅ login rồi
            this.setState({
                loading: false
            });

        } catch (err) {

            this.props.onSetSession({
                user: null
            });

            // ❌ lỗi session -> đá về portal
            window.location.href = PORTAL_LOGIN;
        }
    }

    render () {

        // loading screen
        if (this.state.loading) {
            return (
                // <div
                //     style={{
                //         height: '100vh',
                //         display: 'flex',
                //         justifyContent: 'center',
                //         alignItems: 'center',
                //         fontSize: '20px'
                //     }}
                // >
                //     Đang kiểm tra đăng nhập...
                // </div>
                <div></div>
            );
        }


        return this.props.children;
    }
}

AuthSessionLoader.propTypes = {
    children: PropTypes.node,
    onSetSession: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => ({
    onSetSession: session => dispatch(setSession(session))
});

export default connect(
    null,
    mapDispatchToProps
)(AuthSessionLoader);